import { EventTracking, EventType } from '@app/tracking';
export default class FacebookPixel {
    constructor(pixelId, scriptPath = 'https://connect.facebook.net/en_US/fbevents.js') {
        // @ts-ignore
        !function (f, b, e, v, n, t, s) {
            // @ts-ignore
            if (f.fbq)
                return;
            n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
            // @ts-ignore
            if (!f._fbq)
                f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            // @ts-ignore
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            // @ts-ignore
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            // @ts-ignore
            s.parentNode.insertBefore(t, s);
        }(window, document, 'script', scriptPath);
        fbq('init', pixelId);
        if (window.laravelDebug) {
            console.log(`✅ Facebook Pixel Tracking initialized for "${pixelId}"`);
        }
        this.registerListeners();
    }
    registerListeners() {
        // Page view
        EventTracking.listen(EventType.PageView, ({ title, path }) => {
            fbq('track', 'PageView');
        });
        // Form success
        EventTracking.listen(EventType.FormSuccess, ({ form }) => {
            fbq('track', 'Lead', {
                content_category: 'ContactForm',
                content_name: form
            });
        });
        // Locator search
        EventTracking.listen(EventType.LocatorSearch, ({ searchQuery }) => {
            fbq('track', 'FindLocation');
        });
        // Shop Add Item
        EventTracking.listen(EventType.EcommerceAddItem, event => {
            fbq('track', 'AddToCart', {
                value: event.price,
                currency: event.currency
            });
        });
        // Shop Go to Checkout
        EventTracking.listen(EventType.EcommerceCheckout, event => {
            fbq('track', 'InitiateCheckout', {
                value: event.total,
                currency: event.currency,
                num_items: event.items.length,
                contents: event.items.map(item => ({
                    id: item.variant.sku,
                    quantity: item.quantity
                }))
            });
        });
        // Custom events
        EventTracking.listen(EventType.Track, ({ category, action, label, value = '' }) => {
            if (category == 'E-Mail' || category == 'Phone') {
                fbq('track', 'Contact');
            }
            else {
                fbq('trackCustom', category + ' ' + (action.charAt(0).toUpperCase() + action.slice(1)), {
                    category,
                    label,
                    value
                });
            }
        });
    }
}
